export default __webpack_public_path__ + "static/media/rogano.019b827f.jpg";